'use client'

import { logoutAction } from '@/actions/payload'
import type { FC } from 'react'
import { useEffect, useState } from 'react'
import { Button } from './atoms/Button'

export const PreviewControls: FC = () => {
	const [visible, setVisible] = useState(false)
	useEffect(() => setVisible(window.self === window.top), [])
	if (!visible) return null

	return (
		<div className="pointer-events-none fixed right-0 bottom-0 z-50 space-y-lg p-xl">
			<Button
				intent="primary"
				label="Exit preview"
				className="shadow-2xl"
				icon={['fas', 'arrow-left-from-bracket']}
				onClick={logoutAction}
			/>
		</div>
	)
}
